import axios from 'axios';
import { createHeaders } from './headerUtils';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const birthdayServices = {
    getAllBirthdays: async () => {
        try {
            const headers = createHeaders();
            const response = await axios.get(`${BASE_URL}/birthday/birthday-data`, { headers });
            return response.data;
        } catch (error) {
            console.error('Error fetching all birthdays:', error);
            throw error;
        }
    }
};

export default birthdayServices;
